export default __webpack_public_path__ + "static/media/file-video_darkGray2.14afe6b2.svg";